export default "__VITE_ASSET__e1997c95__"